@use '@design/design-tokens/border-radius/border-radius' as *;

.styledEntityDetails {
  margin: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 500px;
  padding: 20px;
  @include border-radius-r2;
  background: var(--background-soft);
  z-index: var(--z-index-modal);
}

.chartWrapper {
  position: relative;
}

.horizonLabel {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;

  [data-badge='textual'] {
    background: var(--background-soft);
  }
}
